import { forwardRef, type SelectHTMLAttributes } from 'react';
import { Icon } from './Icon.js';
import './Select.css';

export type SelectSize = 'sm' | 'md' | 'lg';

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  uiSize?: SelectSize;
  invalid?: boolean;
}

/** A real native `<select>`, restyled — keeps native keyboard behaviour
 * (type-ahead, arrow-key navigation) for free, which a custom listbox would
 * have to reimplement. Use `Combobox` instead when the option set needs
 * search/filter. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { uiSize = 'md', invalid = false, className, children, ...rest },
  ref
) {
  return (
    <div className={['dpr-select-wrapper', `dpr-select-wrapper--${uiSize}`].join(' ')}>
      <select
        ref={ref}
        className={['dpr-select', invalid ? 'dpr-select--invalid' : null, className]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      >
        {children}
      </select>
      <span className="dpr-select__chevron" aria-hidden="true">
        <Icon name="chevronDown" size={16} />
      </span>
    </div>
  );
});
